import {
  Attribute,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  input,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateTime } from 'luxon';

@Component({
  selector: 'smw-datepicker',
  imports: [],
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() set minDate(date: Date) {
    this.min = date ? DateTime.fromJSDate(date).toFormat('yyyy-MM-dd') : '';
  }

  @Input() set maxDate(date: Date) {
    this.max = date ? DateTime.fromJSDate(date).toFormat('yyyy-MM-dd') : '';
  }

  supportTime = input(false);

  @ViewChild('input', { static: true, read: ElementRef })
  inputField!: ElementRef<HTMLInputElement>;

  inputId = '';
  value = '';
  min = '';
  max = '';

  @Output() dateChange = new EventEmitter();

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};
  onValidationChange: () => void = () => {};

  constructor(
    @Attribute('id') public id: string,
    private element: ElementRef,
    private renderer: Renderer2,
    private changeDetector: ChangeDetectorRef,
  ) {
    if (this.id) {
      this.inputId = this.id;
      this.renderer.removeAttribute(this.element.nativeElement, 'id');
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  writeValue(value: string): void {
    this.value = value || '';
    this.changeDetector.markForCheck();
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidationChange = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.inputField) {
      this.renderer.setProperty(this.inputField.nativeElement, 'disabled', isDisabled);
    }
  }

  onDateChanged($event: Event) {
    this.dateChange.emit($event);
    this.onChange(($event.target as HTMLInputElement).value);
  }

  onBlur() {
    this.onTouched();
  }
}
